<template>
  <div class="user_content">
    <div class="user_header">
      <div class="header_box">
        <span class="goback"
              v-show="backFlag"
              @click="goBack">
          <img src="../assets/images/backpage.png"
               alt="">
        </span>
        <h3 id="webTitle">{{title}}</h3>
        <!-- <span class="close passIconfont  close icon-ftshanchu "
              @click="close"
              v-show="closeFlag"></span> -->
      </div>
    </div>
    <div class="content-box"
         :class="zm?'zm':''">
      <router-view />
    </div>
  </div>
</template>

<script>
import { appPostMessage } from '@/utils/communication'
import { getSessionStorage } from '@/utils/stage'
export default {
  data() {
    return {
      title: '',
      backFlag: false,
      closeFlag: true,
      titlelist: '',
      zm: '',
    }
  },
  watch: {
    $route: function (to, from) {
      if (this.$route.path.indexOf('queryCenter') <= -1) {
        console.log('this.$route.meta.title', this.$route.meta.title)
        const webtitle = document.getElementById('webTitle')
        if (this.$route.path.indexOf('success') == 1) {
          webtitle.innerHTML = this.titlelist[this.$store.getters.web_title]
        } else {
          webtitle.innerHTML = this.titlelist[this.$route.meta.title]
        }
      }
      if (
        this.$route.path.indexOf('logOffScuess') > -1 ||
        this.$route.path.indexOf('LogOffScuess') > -1 ||
        this.$route.path.indexOf('touristLogoffTips1') > -1
      ) {
        this.closeFlag = false
      } else {
        this.closeFlag = true
      }
      if (
        // this.$route.path.indexOf('preamblelogin') > -1 ||
        this.$route.path.indexOf('bindPreamble') > -1 ||
        this.$route.path.indexOf('home') > -1 ||
        this.$route.path.indexOf('Scuess') > -1 ||
        this.$route.path.indexOf('sanfang') > -1 ||
        this.$route.path.indexOf('touristHome') > -1 ||
        this.$route.path.indexOf('accountHome') > -1 ||
        this.$route.path.indexOf('touristLogoffTips1') > -1 ||
        parseInt(this.$route.query.id) == 7
      ) {
        this.backFlag = false
      } else {
        this.backFlag = true
      }
      const titlName = 'title.' + this.$store.getters.web_title
      this.title = this.$t(titlName)
    },
    title() {
      const titlName = 'title.' + this.$store.getters.web_title
      this.title = this.$t(titlName)
    },
  },
  created() {
    this.init()
    if (
      this.$route.path.indexOf('preamblelogin') > -1 ||
      this.$route.path.indexOf('home') > -1 ||
      this.$route.path.indexOf('Scuess') > -1 ||
      this.$route.path.indexOf('sanfang') > -1 ||
      this.$route.path.indexOf('tourist') > -1 ||
      this.$route.path.indexOf('accountHome') > -1 ||
      this.$route.path.indexOf('bindPreamble') > -1 ||
      this.$route.query.noback == 1
    ) {
      this.backFlag = false
    } else {
      this.backFlag = true
    }
  },
  methods: {
    init() {
      if (getSessionStorage('zm') == 1) {
        this.zm = true
      }
      const titlName = 'title.' + this.$store.getters.web_title
      this.title = this.$t(titlName)
      console.log('title.', titlName, this.title)
      this.titlelist = JSON.parse(getSessionStorage('lang1'))
    },
    goBack() {
      if (
        this.$route.path == '/accountVerify' ||
        this.$route.path == '/associatedAccount'
      ) {
        this.$router.push('/')
      } else {
        this.$router.go(-1)
      }
    },
    close() {
      const msg = { code: 1, data: '' }
      appPostMessage(msg)
    },
  },
}
</script>

<style lang="less" scope>
.user_content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .user_header {
    width: 100%;
    height: 154/75rem;
    background: rgba(248, 248, 248, 0.39);
    padding-top: 80/75rem;
    box-sizing: border-box;
    .header_box {
      position: relative;
      .goback {
        width: 40/75rem;
        height: 26/75rem;
        position: absolute;
        left: 26/75rem;
        top: 10/75rem;
      }
      .close {
        width: 96/75rem;
        height: 52/75rem;
        background: rgba(213, 213, 213, 0.08);
        border: 1px solid rgba(0, 0, 0, 0.10196078431372549);
        opacity: 1;
        border-radius: 30/75rem;
        font-size: 21/75rem;
        line-height: 52/75rem;
        text-align: center;
        position: absolute;
        right: 30/75rem;
        top: 0;
      }
      h3 {
        color: #353535;
        font-size: 36/75rem;
        font-family: 'Alibaba PuHuiTi';
        font-weight: 400;
        text-align: center;
      }
    }
  }
  .content-box {
    width: 100%;
    // height: 100%;
    height: calc(100vh - 80px);
    background: #fff;
    position: relative;
  }
  .kefu_box {
    height: calc(100vh - 90px);
  }
}
</style>